import { Component, ViewEncapsulation, Input } from "@angular/core";
import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

@Component({
  selector: "bfx-close",
  templateUrl: "./html/close.component.html",
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class CloseComponent {
  @Input()
  public disabled: boolean = false;

  constructor() {}

  public get nativeDesktop(): boolean {
    return NativeDesktopSupport.isNativeDesktopContainer();
  }

  public closeDialog(): void {
    if (!this.disabled) {
      if (NativeDesktopSupport.isOpenFin()) {
        fin.Application.getCurrentSync().terminate();
      } else {
        NativeDesktopSupport.exit();
      }
    }
  }
}
